<template>
  <el-dialog :append-to-body="true" :visible.sync="value" :show-close="false" width="450px" custom-class="public-pool-drop-actived-dialog" @closed="closed" :close-on-click-modal="false" :close-on-press-escape="false">
    <div class="head">
      <h1 class="title">请选择</h1>
      <i class="el-icon-close" style="cursor: pointer;" @click="closed"></i>
    </div>
    <div class="week-group">
      <el-checkbox-group v-model="weeks">
        <el-checkbox :label="date.id" v-for="(date, i) in list" :key="i">{{date.name}}</el-checkbox>
      </el-checkbox-group>
      <p class="tips">不选中任何一天时，表示不配置保护日</p>
      <div class="button-con">
        <el-button size="small" @click="closed">取消</el-button>
        <el-button type="primary" size="small" @click="handleConfirm">确定</el-button>
      </div>
    </div>
  </el-dialog>
</template>
<script>
export default{
  name: 'PublicPoolWeekPicker',
  data () {
    return {
      value: false,
      weeks: [],
      list: [
        {id: 1, name: '周一'},
        {id: 2, name: '周二'},
        {id: 3, name: '周三'},
        {id: 4, name: '周四'},
        {id: 5, name: '周五'},
        {id: 6, name: '周六'},
        {id: 7, name: '周日'},
      ]
    }
  },
  methods: {
    open (data) {
      this.value = true;
      if (data) {
        this.weeks = data.unconfirmed_weekly_protect_time.split(',').map(v => Number(v));
      }
    },
    closed () {
      this.weeks = [];
      this.value = false;
    },
    handleConfirm () {
      const ids = this.weeks.join(',');
      this.$emit('confirm',ids);
      this.closed();
    }
  },
}
</script>
<style lang="less">
.public-pool-drop-actived-dialog{
  .week-group{
    padding-left: 20px;
    padding-bottom: 20px;
    .el-checkbox{
      margin-top: 20px;
    }
    .tips{
      margin-top: 20px;
      color: #666;
      font-size: 13px;
    }
    .button-con{
      text-align: center;
      margin-top: 40px;
      button{
        width: 100px;
        text-align: center;
      }
    }
  }
}
</style>